import { ReactElement, useContext } from "react";

import { Asset } from "../../generated/gql/graphql";
import useText from "../../hooks/use-text";
import { CategoryContext } from "../../providers/category-provider";
import { ConfirmationModalType } from "../../types/confirm-modal";
import { findRootCategoryById } from "../../utils";
import { LocalizedStrings, SupportedLanguages } from "../../utils/lang";

import CollectionAssetListItem from "./CollectionAssetListItem";

type Props = {
  collectionId: string;
  assets: Asset[];
  setConfirm: (val: ConfirmationModalType) => void;
};

export default function CollectionAssetList(props: Props): ReactElement {
  const { collectionId, assets, setConfirm } = props;

  const { strings } = useText(local);
  const { categories } = useContext(CategoryContext);

  return (
    <div className="w-full">
      <section>
        <header className="flex mb-[25px] px-10">
          <div className="flex-1 pl-10" />
          <div className="flex-1 border-[#e0e0e0] border-solid border-l-1 pl-10 text-[14px] font-bold">
            {strings.table.name}
          </div>
          <div className="flex-1 border-[#e0e0e0] border-solid border-l-1 pl-10 text-[14px] font-bold">
            {strings.table.category}
          </div>
          <div className="flex-1 border-[#e0e0e0] border-solid border-l-1 pl-10 text-[14px] font-bold">
            {strings.table.assetType}
          </div>
          <div className="flex-1 border-[#e0e0e0] border-solid border-l-1 pl-10 text-[14px] font-bold">
            {strings.table.lastModified}
          </div>
        </header>
        {assets.map((asset) => (
          <CollectionAssetListItem
            key={asset.id}
            setConfirm={setConfirm}
            asset={asset}
            categories={categories}
            rawCollectionId={collectionId}
            collectionId={findRootCategoryById(
              asset?.categoryId || "",
              categories
            )}
          />
        ))}
      </section>
    </div>
  );
}

type LocalSchema = {
  table: {
    name: string;
    category: string;
    assetType: string;
    lastModified: string;
  };
};

const local: LocalizedStrings<LocalSchema, SupportedLanguages> = {
  default: {
    table: {
      name: "Name",
      category: "Category",
      assetType: "Assets Type",
      lastModified: "Last Modified",
    },
  },
};
